
import WithModel from '@/mixins/withModel';
import * as OM from '@/model'
import { ModalServices } from '@/services/ModalServices';
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import { LocalizationServices } from '@/services/LocalizationServices';
import { ProjectConfigClient } from '@/services/Services';
import store from '@/store';

@Options({})
export default class fiscalData extends mixins(WithModel) {

    declare localValue: OM.BaseUser;
    
}
